module.exports = "<div class=\"box\">\n  <i class=\"upload ion-android-upload\"></i>\n  <div class=\"title\">{{ file ? file.name : '클릭 혹은 파일을 끌어오세요.' }}</div>\n  <span class=\"filename\"></span>\n  <input type=\"file\" #fileInput class=\"input\" id=\"corp-file\" name=\"corp-file\" accept=\"image/png, image/jpeg, image/jpg, image/gif, .pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" (click)=\"fileInput.value = null\" value=\"\">  \n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/fwdr/detail/file-uploader.html
// module id = ./src/app/containers/fwdr/detail/file-uploader.html
// module chunks = 1